export class RESTClientConfig {
    constructor(config) {
        if (!config) {
            throw "No configuration provided for RestClient. Please, provide the RESTClientConfig service in your application.";
        }
        if (config === null || config === void 0 ? void 0 : config.versionNumber) {
            console.log('v.' + config.versionNumber);
        }
        this._config = config;
    }
    get apiUrl() {
        return this.getConfig().apiUrl;
    }
    get pciApiUrl() {
        return this.getConfig().pciApiUrl;
    }
    get appVersion() {
        return this.getConfig().appVersion;
    }
    get production() {
        return this.getConfig().production;
    }
    get useCookies() {
        return this.getConfig().useCookies;
    }
    get lang() {
        return this.getConfig().lang;
    }
    get getAppWithUpgrades() {
        return this.getConfig().appWithUpgrades;
    }
    get getUpgradeType() {
        return this.getConfig().upgradeType;
    }
    get getUpgradeMessage() {
        return this.getConfig().upgradeMessage;
    }
    get getTokenKey() {
        return this.getConfig().tokenKey;
    }
    get appName() {
        return this.getConfig().appName;
    }
    get deviceType() {
        return this.getConfig().deviceType;
    }
    setLang(lang) {
        this._config.lang = lang;
    }
    setAppVersion(appVersion) {
        this._config.appVersion = appVersion;
    }
    setUpgradeType(upgradeType) {
        this._config.upgradeType = upgradeType;
    }
    setUpgradeMessage(upgradeMessage) {
        this._config.upgradeMessage = upgradeMessage;
    }
    setTokenName(tokenKey) {
        this._config.tokenKey = tokenKey;
    }
    setAppName(appName) {
        this._config.appName = appName;
    }
    setDeviceType(deviceType) {
        this._config.deviceType = deviceType;
    }
    getConfig() {
        return this._config;
    }
}
//# sourceMappingURL=config.js.map